module.exports = __webpack_public_path__ + "img/08_collect_42px_42px_01.ffb19658.png";